/**
 * Curtain Template Components
 * 
 * 窗簾控制 Modal Templates
 */

import { Template01_Modern } from './Template01_Modern';

// Named exports
export { Template01_Modern } from './Template01_Modern';

// Template registry for dynamic loading
export const CurtainTemplates = {
  Template01: () => import('./Template01_Modern').then(m => m.Template01_Modern),
} as const;

// Default export
export default Template01_Modern;
